module.exports = "<div class=\"footer navbar navbar-default navbar-fixed-bottom\">\r\n    <div class=\"container\">\r\n        <div class=\"navbar-text pull-left\">&copy; <span class=\"hidden-xs\">copyright </span>2017</div>\r\n        <div class=\"navbar-text pull-right\">\r\n            <ul>\r\n                <li><a [routerLink]=\"['/privacy']\">Datenschutz</a></li>\r\n                <li><a [routerLink]=\"['/imprint']\">Impressum</a></li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.html
// module id = ./src/app/components/shared/footer/footer.component.html
// module chunks = main